import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class ValoresService extends BaseService<any>{

  private static VALOR_RESOURCE: string = "/valores";

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public saveValor(valor: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    if (valor.id == null) {
      this.post(BaseService.URL_BASE + ValoresService.VALOR_RESOURCE, valor, options, onSuccess);
    } else {
      this.put(BaseService.URL_BASE + ValoresService.VALOR_RESOURCE, valor, options, onSuccess);
    }
  }

  public deleteValor(valor: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + ValoresService.VALOR_RESOURCE + "/" + valor.id, options, onSuccess);
  }

  public getValor(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + ValoresService.VALOR_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getValores(valorFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + ValoresService.VALOR_RESOURCE, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/valores.service.ts